import { HttpErrorResponse, HttpHandler, HttpInterceptor , HttpRequest} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../../../modules/services/auth.service';
import * as uuid from 'uuid';
import { navigationRoutes } from '../../routes/navigation/navigation-routes';
import { Status } from '../../model/response';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    // public languageInfo: Language | undefined;

    constructor(
        public authService: AuthService,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        private injector: Injector
    ) {}

    // Adds necessary headers to the request
    private updateHeaders(request: HttpRequest<any>): HttpRequest<any> {
        if (this.authService.getToken()) {
            return request.clone({
                setHeaders: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.authService.getToken()}`,
                    platform: 'WEB',
                    currencyCode: sessionStorage.getItem('currency') ?? 'USD',
                    languageCode: sessionStorage.getItem('lang') ?? 'en-US',
                },
            });
        } else {
            return request.clone({
                setHeaders: {
                    'Content-Type': 'application/json',
                    platform: 'WEB',
                    currencyCode: sessionStorage.getItem('currency') ?? 'USD',
                    languageCode: sessionStorage.getItem('lang') ?? 'en-US',
                    // 'moo-correlation-id': sessionStorage.getItem('mooCorrelationId') ?? null,
                },
            });
        }
    }

    // Handles error responses from API requests
    private handleError(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
        if (error.status === 401) {
            const languageList = localStorage.getItem('languageList') ?? '';
            const countryList = localStorage.getItem('countryList') ?? '';
            sessionStorage.clear();
            localStorage.clear();
            // If response is unauthorized, redirect user to login
            this.router.navigate([navigationRoutes.navigateToLogin], {
                queryParams: { returnUrl: this.activatedRoute.snapshot.url },
            });
        }

        let errorMessage = {
            status: Status.NOK,
            message: 'Something went wrong. Please try again later.',
        };

        if (error.error) {
            errorMessage = error?.error;
        }

        if (error.error instanceof ProgressEvent) {
            // Handle server unavailable error
            errorMessage = {
                status: Status.NOK,
                message: 'Server Unavailable. Please try again later.',
            };

            // Update UI based on server unavailable error
            const serverUnavailableDiv = window.document.getElementById('server-unavailable');
            if (serverUnavailableDiv) {
                serverUnavailableDiv.innerHTML = errorMessage.message;
            }

            const refreshButtonDiv = window.document.getElementById('refresh-button');
            if (refreshButtonDiv) {
                refreshButtonDiv.classList.remove('d-none');
            }
        } else if (error.error?.message) {
            // Use error message from response if available
            errorMessage.message = error.error.message;
        }

        return throwError(() => errorMessage);
    }

    // Intercepts HTTP requests and handles token refresh and error responses
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        if (request.url.endsWith('api/auth/ott')) {
            request = request.clone({
                setHeaders: {
                    'Content-Type': 'application/json',
                    platform: 'WEB',
                    currencyCode: sessionStorage.getItem('currency') ?? 'USD',
                    languageCode: sessionStorage.getItem('lang') ?? 'en-US',
                },
            });
            return next.handle(request);
        }

        // Update headers for the request
        request = this.updateHeaders(request);

        // Handle request and response
        return next.handle(request).pipe(
            map((event) => {
                return event;
            }),
            catchError((error: HttpErrorResponse) => this.handleError(request, next, error))
        );
    }
}
